export default "__VITE_ASSET__ofae2jP5__"